"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var Filter = (function () {
    function Filter() {
    }
    Filter.filterByRoute = function (offers, routeId) {
        var filteredRoutes = _.filter(offers, function (offer) {
            return _.indexOf(offer.regionIds, routeId) > -1;
        });
        return filteredRoutes;
    };
    Filter.filterCruisesByAvailability = function (cruises) {
        var filteredCruises = _.filter(cruises, function (cruise) {
            return _.find(cruise.cabinPrices, ['available', true]) ? true : false;
        });
        return filteredCruises;
    };
    return Filter;
}());
exports.Filter = Filter;
//# sourceMappingURL=filter.js.map